import ProgramFlyerContainer from './program_flyer_container';

const ProgramFlyer = ProgramFlyerContainer;
export default ProgramFlyer;
